// features/dataSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchApi } from "Config/fetchApi";
import { handleError } from "Helper";

// Thunk untuk mengambil data secara async (lazy loading)
export const fetchDataNotifikasi = createAsyncThunk(
    "ipCam/fetchDataNotifikasi",
    async ({ page = 0, read = false } = {}, { rejectWithValue }) => {
        try {
            const api = fetchApi(); // Menggunakan fetchApi
            const url = `notifikasi/get-list?page=${page}&size=10&read=${read}`;
            const result = await api.get(url);
            return {
                data: result?.data?.data,
                pagination: result?.data?.pagination, // Menyertakan informasi pagination
                notif: {
                    noReadNotif: result?.data?.notif[0]?.noReadNotif,
                    readNotif: result?.data?.notif[0]?.readNotif
                }, // Menyertakan informasi pagination
            };
        } catch (error) {
            handleError(error);
            console.error(error);
            return rejectWithValue(error.response?.data || "An error occurred");
        }
    }
);

const dataSlice = createSlice({
    name: "notifikasi",
    initialState: {
        items: [],
        page: 0, // Mulai dari halaman 0
        paginations: 1, // Total halaman yang tersedia
        notif: 0, // Total halaman yang tersedia
        status: "idle",
        hasMore: true, // Apakah masih ada data yang bisa dimuat
    },
    reducers: {
        resetData: (state) => {
            state.items = [];
            state.page = 0;
            // state.notif = {};
            state.paginations = {};
            state.hasMore = true;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDataNotifikasi.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchDataNotifikasi.fulfilled, (state, action) => {
                // Pastikan hanya meningkatkan halaman jika data berhasil diambil
                if (action.payload.data.length > 0) {
                    // Menyaring data yang sudah ada dalam state.items berdasarkan ID atau UUID
                    const newData = action.payload.data.filter(
                        (item) => !state.items.some(existingItem => existingItem.id === item.id)
                    );

                    // Menambahkan data yang baru (tanpa duplikasi)
                    state.items = [...state.items, ...newData];

                    // Jangan ubah state.page kecuali data untuk halaman tersebut sudah diterima
                    if (newData.length > 0) {
                        state.page += 1; // Increment halaman setelah data diambil
                    }
                } else {
                    state.hasMore = false; // Tidak ada data lagi
                }

                state.paginations = action.payload.pagination; // Perbarui total halaman
                state.notif = action.payload.notif; // Perbarui jumlah notifikasi
                state.status = "succeeded";

                // Periksa apakah jumlah item sudah mencapai totalItems
                if (state.items.length >= action.payload.pagination.totalItems) {
                    state.hasMore = false; // Hentikan pengambilan data
                }
            })
            .addCase(fetchDataNotifikasi.rejected, (state) => {
                state.status = "failed";
            });
    },
});

export const { resetData } = dataSlice.actions;
export default dataSlice.reducer;
